import { useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, CircleAlert } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton.jsx";
import { formatMilesDecimal } from "@/services/Utils.jsx";

import "./ValorizationTooltip.scss";

const ValorizationTooltip = ({ row }) => {
	const navigate = useNavigate();
	const items = row?.original?.items || [];
	const stateId = Number.parseInt(row?.original?.application_orders_state_id, 10);
	const usesPersistedPrice = [2, 4, 5].includes(stateId);

	const getEffectivePrice = (item) => (usesPersistedPrice ? item.price_local_oa : item.price_local);

	const unvaluedProducts = items
		.filter((item) => {
			const price = getEffectivePrice(item);
			if (price === null || price === undefined || price === "") return true;
			const numPrice = Number.parseFloat(price);
			return numPrice === 0 || Number.isNaN(numPrice);
		})
		.map((item) => ({ name: item.product_name, id: item.id }));

	const computedTotal = items.reduce((accumulator, item) => {
		const price = Number.parseFloat(getEffectivePrice(item));
		const quantity = Number.parseFloat(String(item.quantity).replace(",", "."));
		if (Number.isNaN(price) || Number.isNaN(quantity)) return accumulator;
		return accumulator + price * quantity;
	}, 0);

	const totalProducts = items.length;
	const unvaluedCount = unvaluedProducts.length;
	const valuedCount = totalProducts - unvaluedCount;

	const getValuationStatus = () => {
		if (totalProducts === 0) return { type: "empty", icon: null, label: "Sin productos" };
		if (unvaluedCount === 0) return { type: "complete", icon: CheckCircle, label: "Valorización Completa" };
		if (valuedCount === 0) return { type: "none", icon: XCircle, label: "Sin Valorización" };
		return { type: "incomplete", icon: CircleAlert, label: "Valorización Incompleta" };
	};

	const status = getValuationStatus();
	const StatusIcon = status.icon;

	return (
		<div className="tooltip-valorization-container">
			<div className={`tooltip-valorization status-${status.type}`}>
				{valuedCount === 0 && StatusIcon && <StatusIcon size={16} className="valorization-status-icon" />}
				<span>${formatMilesDecimal(computedTotal)}</span>
			</div>

			<div className="tooltip-content">
				<div className={`tooltip-head status-${status.type}`}>
					{StatusIcon && <StatusIcon size={20} />}
					<strong>{status.label}</strong>
				</div>

				<div className="tooltip-body">
					{status.type === "complete" && <p>Todos los productos de esta orden tienen precio asignado.</p>}
					{status.type === "none" && <p>Ningún producto de esta orden tiene precio asignado.</p>}
					{status.type !== "complete" && status.type !== "none" && <p>Algunos productos de esta orden no tienen precio asignado.</p>}

					{unvaluedCount > 0 && (
						<div className="tooltip-list">
							<div>Productos sin valorizar:</div>
							<ul>
								{unvaluedProducts.map((product, i) => (
									<li key={i}>{product.name}</li>
								))}
							</ul>
						</div>
					)}

					{unvaluedCount > 0 && (
						<CustomButton variant="primary" className="tooltip-custom-button" onClick={() => navigate("/productos/etiquetados")}>
							<span>Ir a Mantenedor de Productos</span>
						</CustomButton>
					)}
				</div>
			</div>
		</div>
	);
};

export default ValorizationTooltip;
